import { render } from "./BrandStyriaMediaDesign.vue?vue&type=template&id=030cd3c6"
import script from "./BrandStyriaMediaDesign.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaMediaDesign.vue?vue&type=script&lang=ts"

import "./BrandStyriaMediaDesign.vue?vue&type=style&index=0&id=030cd3c6&lang=scss"
script.render = render

export default script